import _ from 'underscore'
import Vue from 'vue'
import Home from './Home'
import Login from './components/Login'
import PasswordReset from './components/PasswordReset'
import PasswordForgot from './components/PasswordForgot'
import Soc from './components/Soc'
import SocPublic from './components/SocPublic'
import Admin from './components/Admin'
import AdminUsers from './components/AdminUsers'
import AdminUser from './components/AdminUser'
import Serial from './components/Serial'
import SerialList from './components/SerialList'
import License from './components/License'
import Sandbox from './components/Sandbox'
import SandboxRecord from './components/SandboxRecord'
import UserProfile from './components/UserProfile'
import Report from './components/Report'
import ReportSecurityEvent from './components/ReportSecurityEvent'
import ReportLicenseExpiry from './components/ReportLicenseExpiry'
import HashLookup from './components/HashLookup'
import VueRouter from 'vue-router'
import AsyncComputed from 'vue-async-computed'
import auth from './auth'
import store from './store/'
import * as mutationTypes from './store/mutation-types'
import apiWsoc from './apiWsoc'
import apiSandbox from './apiSandbox'
import apiAdmin from './apiAdmin'

import './assets/bootstrap-3.3.7-dist/css/bootstrap.css'
import './assets/css/bootstrap3-print.css'
import 'imports?jQuery=jquery!./assets/bootstrap-3.3.7-dist/js/bootstrap'

import {ClientTable} from 'vue-tables-2'
Vue.use(ClientTable, {}, false)

Vue.use(VueRouter)
Vue.use(AsyncComputed)
Vue.use(apiWsoc)
Vue.use(apiSandbox)
Vue.use(apiAdmin)

function requireAuth (to, from, next) {
  // if there are no, or expired, auth tokens, redirect to the login page
  if (!auth.loggedIn()) {
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  } else {
    // if no stored user profile, use token to attempt to fetch user profile
    if (_.isEmpty(store.getters.user)) {
      console.log('updating user profile')
      Vue.prototype.$apiAdmin.fetchUser(auth.getUserId())
      .then(user => {
        store.commit(mutationTypes.USER_PROFILE_SET, user)
        next()
      })
      .catch({ status: 401 }, () => {
        // not authenticated trying to retrieve user profile
        console.log('not authenticated - redirect to login')
        next({
          path: '/login',
          query: { redirect: to.fullPath }
        })
      })
    } else {
      // we have a token and a user profile, so proceed to next route
      next()
    }
  }
}

function requireAdmin (to, from, next) {
  if (!store.getters.userIsAdmin) {
    next({
      path: '/'
    })
  } else {
    requireAuth(to, from, next)
  }
}

const router = new VueRouter({
  // mode: 'history',
  linkActiveClass: 'active',
  base: __dirname,
  routes: [
    {
      path: '/',
      redirect: '/soc/dashboard'
    },
    {
      path: '/login',
      component: Login,
      name: 'login'
    },
    {
      path: '/logout',
      name: 'logout',
      beforeEnter (to, from, next) {
        console.log('logoff')
        auth.logout()
        next('/login')
      }
    },
    {
      path: '/reset-password',
      component: PasswordReset,
      name: 'reset-password'
    },
    {
      path: '/forgot-password',
      component: PasswordForgot,
      name: 'forgot-password'
    },
    {
      path: '/admin',
      component: Admin,
      name: 'admin',
      beforeEnter: requireAdmin,
      children: [
        {
          path: 'user',
          component: AdminUsers,
          name: 'adminUsers',
          beforeEnter: requireAdmin
        },
        {
          path: 'user/:id',
          component: AdminUser,
          name: 'adminUser',
          beforeEnter: requireAdmin
        }
      ]
    },
    {
      path: '/user',
      component: Soc,
      name: 'user',
      beforeEnter: requireAuth,
      children: [
        {
          path: 'profile',
          component: UserProfile,
          name: 'userProfile',
          beforeEnter: requireAuth
        }
      ]
    },
    {
      path: '/socpublic',
      component: SocPublic,
      name: 'socpublic',
      children: [
        {
          path: 'hashlookup',
          component: HashLookup,
          name: 'hashLookup'
        }
      ]
    },
    {
      path: '/soc',
      component: Soc,
      name: 'soc',
      beforeEnter: requireAuth,
      children: [
        {
          path: 'dashboard',
          component: Home,
          name: 'dashboard',
          beforeEnter: requireAuth
        },
        {
          path: 'serial',
          component: SerialList,
          name: 'serial-list',
          beforeEnter: requireAuth
        },
        {
          path: 'serial/:id',
          component: Serial,
          name: 'serial',
          beforeEnter: requireAuth
        },
        {
          path: 'license',
          name: 'license',
          component: License,
          beforeEnter: requireAuth
        },
        {
          path: 'sandbox',
          name: 'sandbox',
          component: Sandbox,
          beforeEnter: requireAuth
        },
        {
          path: 'sandbox/record/:sha1/:size',
          name: 'SandboxRecord',
          component: SandboxRecord,
          beforeEnter: requireAuth
        },
        {
          path: 'report',
          name: 'report',
          beforeEnter: requireAuth,
          component: Report,
          children: [
            {
              path: 'security-event',
              name: 'reportSecurityEvent',
              component: ReportSecurityEvent,
              beforeEnter: requireAuth
            },
            {
              path: 'license-expiry',
              name: 'reportLicenseExpiry',
              component: ReportLicenseExpiry,
              beforeEnter: requireAuth
            }
          ]
        }
      ]
    }
  ]
})

// the router isn't exposed to plugins, so expose a methods
// to allow the API plugins to redirect the user to login
Vue.prototype.$redirectLogin = () => {
  var redirectPath = router.currentRoute.fullPath

  // some pages will query the API multiple times.
  // to avoid nesting the redirect paths with multiple /login,
  // preserve the redirect path if the router is at /login
  if (router.currentRoute.name === 'login') {
    if ('redirect' in router.currentRoute.query) {
      redirectPath = router.currentRoute.query.redirect
    }
  }

  // call auth.logoff
  router.replace({
    name: 'login',
    query: { redirect: redirectPath }
  })
}

/* eslint-disable no-new */
new Vue({
  router,
  store
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js